import { render, staticRenderFns } from "./RegraImpressaoNova.vue?vue&type=template&id=5294f660"
import script from "./RegraImpressaoNova.vue?vue&type=script&lang=js"
export * from "./RegraImpressaoNova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports